module.exports = __webpack_public_path__ + "img/glasses.6b58a953.svg";